// Purpose: Composes Lara with BayHive palette semantics and scoped structural helpers exactly once.
import './scheduler.js';
import './taskboard.js';
import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';
import bayhivePrimitives from './primitives.js';
import bayhiveSemantic from './semantic.js';
import bayhiveExtensions from './extensions.js';
import componentExceptions from './components/index.js';
import formLayoutStyles from './styles/form-layout.js';
import collectionLayoutStyles from './styles/collection-layout.js';
import compositionUtilityStyles from './styles/utilities.js';
import utilityStyles from './styles/primevue-internals.js';
import touchControlStyles from './styles/touch-controls.js';

export const bayhivePresetOverrides = {
  primitive: bayhivePrimitives,
  semantic: bayhiveSemantic,
  extend: bayhiveExtensions,
  components: componentExceptions,
  css: (context) =>
    [
      formLayoutStyles(context),
      collectionLayoutStyles(context),
      compositionUtilityStyles(context),
      utilityStyles(context),
      touchControlStyles(context),
    ].join('\n'),
};

export const bayhivePreset = definePreset(Lara, bayhivePresetOverrides);

export default bayhivePreset;
